export default __webpack_public_path__ + "static/media/feedBackGood.dde9af1c.svg";